import $ = require('jquery');
/* tslint:disable:no-unused-variable */
/* TypeScript doesn't see usages in Object shorthand notation {x,y,z} */
import Matrix from './common/js/Matrix';
import Modul from './Modul';
import ModulWithImage from './ModulWithImage';
import ModuleInlineEditor from './common/js/ModuleInlineEditor';
import ModulMatrix from './ModulMatrix';
import ModulButton from './ModulButton';
import ModulHtmlCode from './ModulHtmlCode';
import ModulFlashElement from './ModulFlashElement';
import ModulFliestext from './ModulFliestext';
import ModulSpacer from './ModulSpacer';
import ModulTextWithImage from './ModulTextWithImage';
import ModulImageSubtitle from './ModulImageSubtitle';
import ModulTabelle from './ModulTabelle';
import ModulDelicious from './ModulDelicious';
import ModulRss from './ModulRss';
import ModulVideo from './ModulVideo';
import ModulGooglemaps from './ModulGooglemaps';
import ModulGallery from './ModulGallery';
import ModulHr from './ModulHr';
import ModulDownloadDocument from './ModulDownloadDocument';
import ModulHeaderHeading from './ModulHeaderHeading';
import ModulGuestbook from './ModulGuestbook';
import ModulWebcomponent from './ModulWebcomponent';
import ModulSection from './ModulSection';
import ModulSectionContainer from './ModulSectionContainer';
import ModuleOverlay from './common/js/ModuleOverlay';
/* tslint:enable:no-unused-variable */

import AppRegistry from 'diy/AppRegistry';
import DragDrop = require('./common/js/DragDrop');

// Used by edit view
Object.assign(window, {
    Matrix,
    ModuleOverlay,
    Modul,
    ModuleInlineEditor, // also used by moduleserver
    ModulMatrix, // also used by ExistingModuleDragSource
    ModulButton,
    ModulHtmlCode,
    ModulFlashElement,
    ModulFliestext,
    ModulSpacer,
    ModulTextWithImage,
    ModulImageSubtitle,
    ModulTabelle,
    ModulDelicious,
    ModulRss,
    ModulVideo,
    ModulGooglemaps,
    ModulGallery,
    ModulHr,
    ModulDownloadDocument,
    ModulHeaderHeading,
    ModulGuestbook,
    ModulWebcomponent,
    ModulSection,
    ModulSectionContainer
});

$(document).ready(function() {
    $(window).bind('resize', function() {
        if (Modul.getActiveModule()) {
            Modul.getActiveModule().repositionOverlay();
        }
    });
});

let LinkSelector = require<any>('./common/js/LinkSelector');
// Expose to non-webpack code
diy.editor.linkSelector = new LinkSelector();

let upgradeLayer = require<any>('./common/js/UpgradeLayer');
// Expose to non-webpack code
diy.editor.upgradeLayer = upgradeLayer;

let trialLayer = require<any>('./common/js/trialLayer');
(diy as any).editor.trialLayer = trialLayer;
// schedule trial link click handling to be established when document loads
$(function() {
    trialLayer.initTrialLink();
});

let dragDrop = new DragDrop();
AppRegistry.setModuleDragDrop(dragDrop);
$(function() {
    dragDrop.init();
});

require('./logo/js/init');



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/init.ts
 **/